import DOMGL_OBJ from './webgl/class/class-dom-obj.js';
import DOMGL from './webgl/class/class-dom.js';


/*
==============================

概要
1. 事前にVideo全件を DOMGL に登録

==============================
*/
window.RESOURCE = {

	json : document.getElementById("json-data"),

	items : {},

	keys : [],

	once( elem ){

		//
		this.data = JSON.parse(this.json.textContent);
		this.data.forEach( (v,i) =>{
			const obj = new DOMGL_OBJ( v, 'black' );
			this.items[ obj.key ] = obj;
			this.keys.push( obj.key );
		});

		//
		Object.keys( this.items ).forEach( (key) => {
			const v = this.items[key];
			v.gl = new DOMGL( v );
		});

	}

}